"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconChargeOnTheGo = function IconChargeOnTheGo(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M28.028 12.984A4.16 4.16 0 0 0 25.34 12H11v2h14.34l.184.008c.488.041.95.247 1.307.587l8.712 8.352 9.042 1.234.117.025a1.103 1.103 0 0 1 .775 1.26l-.86 4.631-.029.119a1.1 1.1 0 0 1-1.056.784H39.9a5.002 5.002 0 0 0-9.8 0H18.9a5.002 5.002 0 0 0-9.8 0H3.75l-.102-.007A.75.75 0 0 1 3 30.25V27H1v3.25l.005.168A2.75 2.75 0 0 0 3.75 33H9.1a5.002 5.002 0 0 0 9.8 0h11.2a5.002 5.002 0 0 0 9.8 0h3.63l.186-.005a3.1 3.1 0 0 0 2.867-2.534l.86-4.628.032-.207a3.1 3.1 0 0 0-.549-2.151l-.126-.167a3.1 3.1 0 0 0-1.925-1.106l-8.418-1.149-8.245-7.905zM24.7 17.94l-2.94 5.88h1.47v4.41l2.94-5.88H24.7zM38 41v2H10v-2zm0-9a3 3 0 1 0-6 0 3 3 0 0 0 6 0m-3.03-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m0 1a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1M17 32a3 3 0 1 0-6 0 3 3 0 0 0 6 0m-3-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m0 1a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1M12 17v1H5v-1zm-1 5v-1H4v1z",
    clipRule: "evenodd"
  })));
};

export { IconChargeOnTheGo, IconChargeOnTheGo as default };
